// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Y7w0","type":"styles_type__3hq-s","choices":"styles_choices__qrGEZ"};